

import LayoutMain from '@/layout';
import setting from '@/setting';
let routePre = setting.routePre;

const meta = {
  auth: true,
};

const pre = 'channel_';

export default {
  path: routePre + '/channel',
  name: 'channel',
  header: 'channel',
  redirect: {
    name: `${pre}index`,
  },
  component: LayoutMain,
  children: [
	
	{
	  path: 'index',
	  name: `${pre}index`,
	  meta: {
	    auth: ['channel'],
	    title: '渠道',
	  },
	  component: () => import('@/pages/channel/index'),
	},
	
	{
	  path: 'add',
	  name: `${pre}add`,
	  meta: {
	    auth: ['client-add'],
	    title: '添加客户',
		activeMenu: routePre + '/client/index',
	  },
	  component: () => import('@/pages/client/add'),
	},
	
  ],
};
